import React, {CSSProperties, FC, ReactNode} from 'react';
import styled from 'styled-components';

import {fontSizes, fontWeights} from '../../../../libs/shared/ui/src/styles/fontStyles';
import {StartGuideProgressBar, StartGuideProgressBarProps} from '../../startGuide/startGuideProgressBar';

/*
 * Props.
 */

interface AdminSetupGuideScreenProps {
  className?: string;
  style?: CSSProperties;
  title: ReactNode;
  description: ReactNode;
  children: ReactNode;
  progress?: Pick<StartGuideProgressBarProps, 'completedSteps' | 'hasCompletedAllTasks' | 'totalSteps'>;
  hasLargeRowGap?: boolean;
}

/*
 * Style.
 */

const StyledContainerDiv = styled.div`
  padding: 30px 14px;

  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 30px;
`;

const StyledHeaderContainerDiv = styled.div`
  width: 100%;
  padding: 0px 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const StyledHeaderTextContainerDiv = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const StyledTitleContainerDiv = styled.div`
  color: ${(p) => p.theme.greys.shade90};
  font-size: 24px;
  font-weight: ${fontWeights.semibold};
  line-height: 31px;
`;

const StyledDescriptionContainerDiv = styled.div`
  color: ${(p) => p.theme.greys.shade70};
  font-size: ${fontSizes.medium};
  line-height: 22px;
`;

const StyledContentContainerDiv = styled.div<{$hasLargeGap?: boolean}>`
  width: 100%;
  padding: 0px 16px;
  display: flex;
  flex-direction: column;
  gap: ${(p) => (p.$hasLargeGap ? 24 : 12)}px;
`;

/*
 * Component.
 */

export const AdminSetupGuideScreen: FC<AdminSetupGuideScreenProps> = (props) => (
  <StyledContainerDiv className={props.className} style={props.style}>
    <StyledHeaderContainerDiv>
      <StyledHeaderTextContainerDiv>
        <StyledTitleContainerDiv>{props.title}</StyledTitleContainerDiv>
        <StyledDescriptionContainerDiv>{props.description}</StyledDescriptionContainerDiv>
      </StyledHeaderTextContainerDiv>
      {props.progress && (
        <StartGuideProgressBar
          isAdminSetupGuide
          completedSteps={props.progress.completedSteps}
          totalSteps={props.progress.totalSteps}
          hasCompletedAllTasks={props.progress.hasCompletedAllTasks}
          initialProgressWidth="8px"
        />
      )}
    </StyledHeaderContainerDiv>
    <StyledContentContainerDiv $hasLargeGap={props.hasLargeRowGap}>
      {props.children}
    </StyledContentContainerDiv>
  </StyledContainerDiv>
);
